module.exports = __webpack_public_path__ + "img/NZAvsLDE.190be1f0.png";